import axiosInstance from './axiosInstance';

const createKriptonian = (data) =>
  axiosInstance.post('/internal/admin/kriptonian/k2ps', data);

export default createKriptonian;
